export const STATUS_PROPOSAL = {
  assignments: 1,
  rejected: 2,
  awaitingApproval: 3,
  finalized: 4,
  pending: 5,
};
